import {
  checkConfirmPassword,
  checkNewPassword,
  getTextField,
  ValidationError,
} from '@lender/utils';

import { PASSWORD_VALIDATION_RULES } from 'constants/auth';

export const getPasswordField = () =>
  PASSWORD_VALIDATION_RULES.requirements.reduce(
    (field, { regexp, error }) => field.matches(regexp, error),
    getTextField().min(
      PASSWORD_VALIDATION_RULES.minLength,
      PASSWORD_VALIDATION_RULES.minLengthError,
    ),
  );

export const getNewPasswordField = () =>
  getPasswordField().test('match', ValidationError.NewPasswordIsTheSame, checkNewPassword);

export const getConfirmPasswordField = () =>
  getPasswordField().test('match', ValidationError.PasswordDoNotMatch, checkConfirmPassword);
